/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconCalendarStar(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 20 20"
      color="currentColor"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.247}
        d="M18.64 14.56V4a1.92 1.92 0 0 0-1.92-1.92H3.28A1.92 1.92 0 0 0 1.36 4v10.56"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.247}
        d="M1.36 6.88v10.56a1.92 1.92 0 0 0 1.92 1.92h13.44a1.92 1.92 0 0 0 1.92-1.92V6.88"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.247}
        d="M4.96 3.813V.64M14.835.64v3.173"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.247}
        d="M9.315 7.211c.216-.663 1.154-.663 1.37 0l.447 1.376a.72.72 0 0 0 .684.497h1.446c.698 0 .988.893.423 1.303l-1.17.85a.72.72 0 0 0-.26.804l.446 1.376c.215.663-.544 1.214-1.108.804l-1.17-.85a.72.72 0 0 0-.846 0l-1.17.85c-.564.41-1.323-.141-1.108-.804l.447-1.376a.72.72 0 0 0-.262-.805l-1.17-.85c-.564-.41-.274-1.302.424-1.302h1.446a.72.72 0 0 0 .684-.497z"
      />
    </svg>
  );
}
